var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.6003 0.38119L6.99963 5.98183L1.39899 0.38119L0.380859 1.39932L5.9815 6.99996L0.380859 12.6006L1.39899 13.6187L6.99963 8.01808L12.6003 13.6187L13.6184 12.6006L8.01776 6.99996L13.6184 1.39932L12.6003 0.38119Z"}));
}

Close.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = Close;

Close.default = Close;
